import { IconBookmark, IconDownload, IconInfo, IconKey, IconPhone, IconPlug, IconPower, IconShare, IconThumbUp, IconUser } from '@assets/images/icon';
import { IconCard, IconTopology } from '@assets/images/main';
import { accessAutoMain, accessLite1, accessProSchemeThumb } from '@assets/images/main/access/product';

export default {
  a: [
    { text: '技術方式', icon: IconInfo },
    { text: 'モバイル出入', icon: IconPhone },
    { text: 'NFC出入', icon: IconCard },
    { text: '顔認証出入', icon: IconUser },
    { text: 'アクセスタグ', icon: IconKey },
    { text: '出入記録の保存', icon: IconDownload },
    { text: '電源入力', icon: IconPlug },
    { text: 'サーバー通信', icon: IconTopology },
    { text: '主な利用場所', icon: IconBookmark },
    { text: '推奨環境', icon: IconThumbUp },
    { text: '外部連携', icon: IconShare },
  ],
  b: [
    { text: 'Bluetooth 5、マイクロ波' },
    { text: '対応' },
    { text: '非対応' },
    { text: '非対応' },
    { text: '非対応' },
    { text: '入室記録の保存' },
    { text: 'DC 12V, 24V（極性なし）' },
    { text: 'Wi-Fi' },
    { text: 'アパート、寮、病院などの自動化空間' },
    { text: '車両追跡、資産追跡' },
    { text: '非対応' },
  ],
  c: [
    { text: 'Bluetooth 5, NFC' },
    { text: '対応' },
    { text: '対応' },
    { text: '非対応' },
    { text: '対応' },
    { text: '出入記録の保存' },
    { text: 'PoE' },
    { text: 'PoE' },
    { text: 'スマートオフィス、スタジオ、共有施設' },
    { text: '車両追跡、資産追跡' },
    { text: 'API 提供' },
  ],
  d: [
    { text: 'Bluetooth 5, NFC, AI' },
    { text: '対応' },
    { text: '対応' },
    { text: '対応' },
    { text: '対応' },
    { text: '出入記録の保存' },
    { text: '12V / 3A アダプター' },
    { text: 'PoE, Wi-Fi' },
    { text: '高級ビル、共用エントランス、管理室' },
    { text: 'ヤード、港、物流センター、工事現場' },
    { text: 'API 提供' },
  ],
  spec: [
    {},

    {
      image: accessAutoMain,
      link: '/access/auto',
      title: 'Access Auto',
      desc: '',
    },

    {
      image: accessLite1,
      link: '/access/pro',
      title: 'Access Lite',
      desc: '',
    },

    {
      image: accessProSchemeThumb,
      link: '/access/accessory',
      title: 'Access Pro',
      desc: '',
    },
  ],
};
